import React from "react";
import { faqsDrone } from "../../data/faqsDrone.json";
import { faqsNavIC } from "../../data/faqsNavIC.json";
import { faqsHHN } from "../../data/faqHHN.json";
import { faqsGC } from "../../data/faqsGC.json";
import BacktoTopCom from "../helpers/BackToTopCom";
import FooterHomeOne from "../partials/Footers/FooterHomeOne";
import HeaderHomeOne from "../partials/Headers/HeaderHomeOne";
import MainFaqSection from "./MainFaqSection";

function FAQ() {
  return (
    <>
      <HeaderHomeOne />
      <MainFaqSection
        faqsDrone={faqsDrone}
        faqsNavIC={faqsNavIC}
        faqsHHN={faqsHHN}
        faqsGC={faqsGC}
      />
      <FooterHomeOne />
      <BacktoTopCom />
    </>
  );
}

export default FAQ;
